import { createSelector } from 'reselect';
import { getVariant } from '../organism/ABFeature/Feature';

export const getBanner: (state: any) => any = state => state?.banner || {};

const getPlpExtendedBanner: (state: any) => any = state => state?.plpExtendedBanner || {};

const getPlpExtendedBannerImages = createSelector(
  getPlpExtendedBanner,
  ({ data: { component = {} } = {} }) => {
    const banner = component?.banners || [];
    return {
      showPlpExtendedBanner: !!(banner.length > 0 && getVariant('plpExtendedBanner')),
      banners: banner,
      extendedBannerCarouselTimer: component?.carouselTimer || 5
    };
  }
);

export const getPlpBanners = createSelector(getBanner, ({ data: { page = {} } = {} }) => {
  const slots = page?.slots || [];
  if (slots.length > 0) {
    const banners = slots[0].component.banners || [];
    return banners || [];
  }
  return [];
});

export default getPlpExtendedBannerImages;
